module.exports = __webpack_public_path__ + "img/225.missing_coffe_tea.82ca7a27.svg";